import { AdminService, AuthService, UserService, XepptClient } from '@xeppt/xeppt-sdk';

export const sdk = new XepptClient(
    {
        baseURL: process.env.REACT_APP_BACKEND_URL
    },
    () => {
        localStorage.removeItem('client-metadata');
    }
);

export const apiAdminService = new AdminService(sdk);
export const apiAuthService = new AuthService(sdk);
export const apiUserService = new UserService(sdk);
